export default __webpack_public_path__ + "static/media/Raider's Armbands of the Covert Trail.929101de.jpg";